/**
 * Core application UI actions
 */

import { LocalStorageHelper } from '../../../helpers';
import { logger } from '../../../helpers/logger';
import { uiConstants } from './actionTypes';
import { appApi } from '../../../services/appApi';
import queryString from 'query-string';

//////////////////////////////////////////////////////////////////////////
//
// Helper functions
//

const _initializeUiAddin = (payload) => ({
    type: uiConstants.UI_INITIALIZE_ADDIN,
    payload,
});

/**
 * Initializes the addin
 * @param inputLocation
 */
const initializeAddinUi = (inputLocation: Location) => {
    return async (dispatch) => {
        logger.info('initializeAddinUi action called', 'Init');
        let displayLanguage = LocalStorageHelper.storeContainsKey(
            LocalStorageHelper.storeKeys.LANG,
        )
            ? LocalStorageHelper.storeGetObject(
                  LocalStorageHelper.storeKeys.LANG,
              )
            : navigator.language.substring(0, 2).toLowerCase();

        const queryStringParsed = queryString.parse(inputLocation.search);
        const pageMode = queryStringParsed.page;

        // Need to add logic to check is language isn't in the list
        // of supported languages - select "EN" then
        const config = await appApi.getConfig();
        if (!config.supportedLanguages.includes(displayLanguage))
            displayLanguage = 'en';

        dispatch(
            _initializeUiAddin({
                displayLanguage: displayLanguage,
                pageMode: pageMode,
            }),
        );
    };
};

export const uiActions = {
    initializeAddinUi,
};
